export default [
  {
    id: '1',
    src: require('../../assets/images/avatars/1.svg')
  },
  {
    id: '2',
    src: require('../../assets/images/avatars/2.svg')
  },
  {
    id: '3',
    src: require('../../assets/images/avatars/3.svg')
  },
  {
    id: '4',
    src: require('../../assets/images/avatars/4.svg')
  },
  {
    id: '5',
    src: require('../../assets/images/avatars/5.svg')
  },
  {
    id: '6',
    src: require('../../assets/images/avatars/6.svg')
  },
  {
    id: '7',
    src: require('../../assets/images/avatars/7.svg')
  },
  {
    id: '8',
    src: require('../../assets/images/avatars/8.svg')
  },
  {
    id: '9',
    src: require('../../assets/images/avatars/9.svg')
  },
  {
    id: '10',
    src: require('../../assets/images/avatars/10.svg')
  },
  {
    id: '11',
    src: require('../../assets/images/avatars/11.svg')
  },
  {
    id: '12',
    src: require('../../assets/images/avatars/12.svg')
  },
  {
    id: '13',
    src: require('../../assets/images/avatars/13.svg')
  },
  {
    id: '14',
    src: require('../../assets/images/avatars/14.svg')
  },
  {
    id: '15',
    src: require('../../assets/images/avatars/15.svg')
  },
  {
    id: '16',
    src: require('../../assets/images/avatars/16.svg')
  },
  {
    id: '17',
    src: require('../../assets/images/avatars/17.svg')
  },
  {
    id: '18',
    src: require('../../assets/images/avatars/18.svg')
  },
  {
    id: '19',
    src: require('../../assets/images/avatars/19.svg')
  },
  {
    id: '20',
    src: require('../../assets/images/avatars/20.svg')
  },
  {
    id: '21',
    src: require('../../assets/images/avatars/21.svg')
  },
  {
    id: '22',
    src: require('../../assets/images/avatars/22.svg')
  },
  {
    id: '23',
    src: require('../../assets/images/avatars/23.svg')
  },
  {
    id: '24',
    src: require('../../assets/images/avatars/24.svg')
  },
  {
    id: '25',
    src: require('../../assets/images/avatars/25.svg')
  },
  {
    id: '26',
    src: require('../../assets/images/avatars/26.svg')
  },
  {
    id: '27',
    src: require('../../assets/images/avatars/27.svg')
  },
  {
    id: '28',
    src: require('../../assets/images/avatars/28.svg')
  },
  {
    id: '29',
    src: require('../../assets/images/avatars/29.svg')
  },
  {
    id: '30',
    src: require('../../assets/images/avatars/30.svg')
  },
  {
    id: '31',
    src: require('../../assets/images/avatars/31.svg')
  },
  {
    id: '32',
    src: require('../../assets/images/avatars/32.svg')
  }

]
